export default __webpack_public_path__ + "c876199c044125fe260eb6fd3dbdc70a.svg";